const OnBoardWhiteLabelPartyApiUrls = {
  CREATE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/on-board-white-label-party/create`,
  
};

export default OnBoardWhiteLabelPartyApiUrls
